import { SidebarItem } from "../interfaces/sidebarItems";

export const shortcuts: SidebarItem[] = [
  {
    label: "Page Name",
    href: "#",
    icon: "mdi:map-marker-path",
    external: true,
  },
];

export const mainItems: SidebarItem[] = [
  { label: "Friends", href: "/community/friends", icon: "mdi:account-multiple" },
  { label: "Memories", href: "/community/memories", icon: "mdi:clock-outline" },
  { label: "Saved", href: "/community/saved", icon: "mdi:bookmark-outline" },
  { label: "Groups", href: "/community/groups", icon: "mdi:account-group-outline" },
  { label: "Reels", href: "/community/reels", icon: "mdi:play-circle-outline" },
  { label: "Marketplace", href: "/community/marketplace", icon: "mdi:storefront-outline" },
  { label: "Jobs", href: "/community/jobs", icon: "mdi:briefcase" },
  { label: "Pages", href: "/community/pages", icon: "mdi:map-marker-path" },
];
